const dateTag = '[object Date]';
const objectTag = '[object Object]';
const slice = Array.prototype.slice;

function getTag(value) {
  return toString.call(value);
}
function isTypeOf(value, tag) {
  return getTag(value) === tag;
}
function isPlainObject(value) {
  return getTag(value) === objectTag;
}
function toArray(arrayLike, from, to) {
  return slice.call(arrayLike, from, to);
}
function merge(object, ...args) {
  const sources = toArray(args, 0);
  if (sources.length === 0) {
    return object;
  }
  for (let _a = 0, target = sources; _a < target.length; _a++) {
    const source = target[_a];
    if (!isTypeOf(source, objectTag)) {
      continue;
    }
    for (let _b = 0, _c = Object.keys(source); _b < _c.length; _b++) {
      const key = _c[_b];
      const value = source[key];
      if (isTypeOf(object[key], objectTag)) {
        object[key] = merge(object[key], value);
      } else {
        object[key] = clone(value);
      }
    }
  }
  return object;
}
/**
 * 克隆
 * @param {T} value
 * @returns {T}
 */
function clone(value) {
  if (value === null) {
      return value;
  }
  const type = typeof value;
  if (type === 'number' || type === 'string' || type === 'boolean' || type === 'undefined') {
      return value;
  }
  if (Array.isArray(value)) {
      return value.map(clone);
  }
  if (isPlainObject(value)) {
      return merge({}, value);
  }
  if (isTypeOf(value, dateTag)) {
      return new Date(value.getTime());
  }
  return value;
}

module.exports = clone;



// WEBPACK FOOTER //
// ./src/utils/clone.js